import { Box, Grid, IconButton, TextField } from "@material-ui/core";
import { useAppTheme } from "constants/theme";
import {
  getParameterByName,
  removeParam,
  updateURLParameter,
} from "helpers/utils";
import React, { useCallback, useEffect, useRef, useState } from "react";
import debounce from "lodash/debounce";
import { Close } from "@material-ui/icons";
import { SearchIcon } from "assets/icons/icons";

export function TextFilter({
  locationSearch,
  setLocationSearch,
  filterKey,
  label,
  ...props
}) {
  const handleChange = (prop) => (e) => {
    const value = e.target.value || "";
    const search = updateURLParameter(locationSearch, prop, value);
    setLocationSearch(search);
  };

  return (
    <TextField
      variant="standard"
      margin="normal"
      label={label}
      value={getParameterByName(filterKey, locationSearch) || ""}
      onChange={handleChange(filterKey)}
      style={{
        input: {
          color: "#fff !Important",
          "&::placeholder": {
            opacity: 1,
          },
        },
        label: { color: "#8c8c8c" },
      }}
      {...props}
    />
  );
}
